import React from "react";

import { useAuth } from "#app/lib/auth-context";
import { readJWT } from "#app/lib/jwt";

/**
 * The signed-in user's email, read from the access token's JWT payload.
 * `null` while signed out (or when the token carries no email claim) — the
 * account-menu chrome that consumes this hides itself on `null`.
 */
export function useAuthEmail(): string | null {
  const { state } = useAuth();
  return React.useMemo(() => {
    if (!state.accessToken) return null;
    const payload = readJWT(state.accessToken);
    return (payload.email as string) ?? null;
  }, [state.accessToken]);
}
